import type { SideMenuItemProps } from '@halo/ui-react';
import { SideMenuItem } from '@halo/ui-react';
import type { Session } from '@halo/chat-sdk';
import type { ReactNode } from 'react';
import { RippleEffect } from '@halo/ui-chat-react';

interface ChatItemProps extends Omit<SideMenuItemProps, 'itemKey'> {
  session: Session;
  children: ReactNode;
}

export const ChatItem = memo(function ChatItem({ session, children, ...props }: ChatItemProps) {
  return (
    <RippleEffect>
      <SideMenuItem
        className="ChatItem"
        itemKey={session.chat_id}
        display="flex"
        alignItems="center"
        p="2"
        gap="3"
        borderBottom="1px solid"
        borderColor="border.subtle"
        boxSizing="content-box"
        _hover={{
          bg: 'brand.10',
        }}
        _selected={{ bg: 'brand.10' }}
        borderRadius="lg"
        {...props}
      >
        {children}
      </SideMenuItem>
    </RippleEffect>
  );
});
